module.exports = __webpack_public_path__ + "static/media/analytics-mobile.cae53fad.jpg";